import { render, staticRenderFns } from "./RealtimeUsersDetailsTable.vue?vue&type=template&id=29e96a49&scoped=true"
import script from "./RealtimeUsersDetailsTable.vue?vue&type=script&lang=js"
export * from "./RealtimeUsersDetailsTable.vue?vue&type=script&lang=js"
import style0 from "./RealtimeUsersDetailsTable.vue?vue&type=style&index=0&id=29e96a49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e96a49",
  null
  
)

export default component.exports